import SolutionPage from './index';

export default function BlockchainPage() {
  return <SolutionPage pageId="blockchain" />;
}
